import React from 'react';
import classes from './buildcontrols.module.css';
import BuildControl from './BuildControl/BuildControl';

//import { checkPropTypes } from 'prop-types';
const controls = [
    {label: 'Salad', type: 'salad'},
    {label: 'Bacon', type: 'bacon'},
    {label: 'Cheese', type: 'cheese'},
    {label: 'Meat', type: 'meat'},
    {label: 'Tomato', type: 'tomato'},
    {label: 'Onion', type: 'onion'}
];

const buildControls = (props) => (
    <div className={classes.BuildControls}>
        <p>Current price: $<strong>{props.price.toFixed(2)} </strong>  </p>
    {controls.map(ctrl => (
        <BuildControl 
        key={ctrl.label}
        label={ctrl.label}
        added={() => props.ingredientAdded(ctrl.type)}
        removed={() => props.ingredientRemoved(ctrl.type)}
        // does not work--crashes 
        //a short time later after other nonrelated changes it started woeking!! UGH
       // ordered={this.purchaseHandler} - Max DID NOT have this line??WHY?
        disabled={props.disabled[ctrl.type]}
        /> 
    ) )}
    <button className={classes.OrderButton}
    disabled={!props.purchasable}
    onClick={props.ordered}> {props.isAuth ? 'ORDER NOW!' : 'Sign Up to Order!'}</button>
 </div>
);

export default buildControls;